export const authenticationConstants = {
    LOGIN_REQUEST: 'LOGIN_REQUEST',
    LOGIN_SUCCESS: 'LOGIN_SUCCESS',
    LOGIN_FAILURE: 'LOGIN_FAILURE',
    LOGOUT: 'LOGOUT',
    REGISTER_REQUEST: 'REGISTER_REQUEST',
    REGISTER_SUCCESS: 'REGISTER_SUCCESS',
    REGISTER_FAILURE: 'REGISTER_FAILURE',
    OAUTH_SUCCESS: 'OAUTH_SUCCESS',
    OAUTH_FAILURE: 'OAUTH_FAILURE',
    CLEAR_ERROR: 'CLEAR_ERROR',
    MODIFY_SUCCESS: 'MODIFY_SUCCESS',
    MODIFY_DISPLAY_SETTINGS_SUCCESS: 'MODIFY_DISPLAY_SETTINGS_SUCCESS',
    MODIFY_PRIVACY_SETTINGS_SUCCESS: 'MODIFY_PRIVACY_SETTINGS_SUCCESS',
    REDIRECT_URL: 'REDIRECT_URL'
};
